import { fellesIntl } from "./intl";

export * from "./intl";

export default fellesIntl;
